<template>
    <dlr-custom-modal
        v-if="show"
        :title="Lang.get('employeedashboard::pages/dashboard/search_profile.title', {
            'first_name': $page.props.auth.user.first_name})"
        :modal-id="`searchProfileModal`"
        @submitRequest="saveTimesOfAsking"
    >
        <template #content>
            <p class="font-poppins font-weight-bold color-blue mb-4 mr-2 mr-sm-0">
                {{ Lang.get('employeedashboard::pages/dashboard/search_profile.subtitle') }}
            </p>
            <p class="font-poppins color-dark-blue mb-4 mr-2">
                {{
                    Lang.get('employeedashboard::pages/dashboard/search_profile.description', {
                        'first_name': $page.props.auth.user.first_name
                    })
                }}
            </p>
        </template>
        <template #footer>
            <a
                @click.stop
                :href="route('nl.employee-search-profile.question', {
                    return_url: $page.props.auth.user.search_profile.return_url
                })"
               class="btn btn-primary btn-orange border-radius-19 px-5 font-poppins font-weight-bold mb-3 mt-3 col-sm-12 col-lg-6"
            >
                {{ Lang.get('employeedashboard::pages/dashboard/search_profile.go_to_questions') }}
            </a>
            <p class="text-warning text-center col-sm-12 col-lg-6">
                {{ Lang.get('employeedashboard::pages/dashboard/search_profile.fill_in_time') }}
            </p>
        </template>
    </dlr-custom-modal>
</template>

<script>
import DlrCustomModal from '@/Shared/Modal/DlrCustomModal';

export default {
    components: {
        DlrCustomModal,
    },
    data() {
        return {
            show: this.$page.props.auth.user.search_profile.ask_to_complete,
        };
    },
    mounted() {
        $('#searchProfileModal').modal('show');
    },
    methods: {
        saveTimesOfAsking() {
            this.$inertia.post(this.route('nl.employeedashboard.search_profile.closed.attempt'));
        }
    }
};
</script>
